import { render, staticRenderFns } from "./CopyOptionBudgets.vue?vue&type=template&id=10d77d39"
import script from "./CopyOptionBudgets.vue?vue&type=script&lang=ts"
export * from "./CopyOptionBudgets.vue?vue&type=script&lang=ts"
import style0 from "./CopyOptionBudgets.vue?vue&type=style&index=0&id=10d77d39&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports